<template>
  <v-container>
    <v-row justify="start" no-gutters class="my-2">
      <v-btn exact text :to="{ name: 'DeliverySlipIndex' }">
        <v-icon small left>fa-chevron-left</v-icon>Retour
      </v-btn>
    </v-row>
    <section v-if="deliverySlip">
      <v-card class="mb-2">
        <v-card-text>
          <DeliverySlipFields
            v-bind.sync="deliverySlip"
            :valid.sync="fieldsValid"
            read-only
          ></DeliverySlipFields>
        </v-card-text>
      </v-card>
      <v-card>
        <v-card-text>
          <DeliverySlipCloserGrid :items="items"></DeliverySlipCloserGrid>
        </v-card-text>
      </v-card>
    </section>
    <section v-else>
      <v-card class="mb-2">
        <v-card-text>
          <v-skeleton-loader type="card-heading"></v-skeleton-loader>
        </v-card-text>
      </v-card>
      <v-card>
        <v-card-text>
          <v-skeleton-loader
            type="table-heading, table-row-divider@4, table-tfoot"
          ></v-skeleton-loader>
        </v-card-text>
      </v-card>
    </section>
    <v-row align="center" justify="end" no-gutters class="mt-2">
      <v-btn
        color="primary"
        :disabled="!deliverySlip"
        @click="updateDeliverySlip"
        :block="$vuetify.breakpoint.xsOnly"
        :large="$vuetify.breakpoint.smAndDown"
      >
        <v-icon left small>fa-save</v-icon>Enregistrer
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
import { round10 } from "round10";
import moment from "moment";
import { DeliverySlipFields, DeliverySlipCloserGrid } from "../components";
export default {
  name: "DeliverySlipCloser",
  components: {
    DeliverySlipFields,
    DeliverySlipCloserGrid
  },
  props: {
    id: {
      required: true
    }
  },
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.getData();
    });
  },
  async beforeRouteUpdate() {
    await this.getData();
  },
  computed: {
    ...mapGetters([
      "getProducts",
      "getInventoryRecords",
      "getOrderTemplates",
      "getSuppliers",
      "getStoreId"
    ]),
    getFilteredItems() {
      if (this.deliverySlip.supplier) {
        const supplier = this.getSuppliers.find(
          x => x.id_fournisseur === this.deliverySlip.supplier
        );
        if (supplier && supplier.data) {
          return this.items.filter(
            x =>
              x.data &&
              x.est_intermediaire === false &&
              x.data.tags
                .map(t => t.toLowerCase())
                .includes(supplier.data.supplier_tag.toLowerCase())
          );
        }
      }
      return this.items;
    }
  },
  data() {
    return {
      fieldsValid: false,
      deliverySlip: undefined,
      items: [],
      loading: false,
      template: undefined,
      templateId: null
    };
  },
  methods: {
    async getData() {
      try {
        this.$store.dispatch("slo");
        this.deliverySlip = await api.retrieveDeliverySlip(this.id);
        this.deliverySlip.supplier = Number(this.deliverySlip.supplier);
        this.items = [...this.deliverySlip.delivery_slip_products].map(x => {
          const product = this.getProducts.find(p => p.id === x.fk_product);
          if (product) {
            return {
              ...product,
              ...x,
              quantity_ordered: Number(x.quantity_ordered),
              quantity_received: Number(x.quantity_received),
              quantity_received_init: Number(x.quantity_received)
            };
          } else {
            return {
              ...x,
              quantity_ordered: Number(x.quantity_ordered),
              quantity_received: Number(x.quantity_received),
              quantity_received_init: Number(x.quantity_received)
            };
          }
        });
      } finally {
        this.$store.dispatch("elo");
      }
    },
    getQuantity(item) {
      const record = this.getInventoryRecords.find(
        x => x.fk_product === item.id
      );
      if (record) {
        return round10(Number(record.computedQuantity), -2);
      } else {
        return null;
      }
    },
    async updateDeliverySlip() {
      try {
        this.$store.dispatch("slo");
        const data = {
          ...this.deliverySlip,
          is_receive: true
        };
        const tasks = [];
        this.items.forEach(x => {
          const d = {
            ...x
          };
          tasks.push(api.patchDeliverySlipProduct(x.id, d));
          const r = {
            fk_product: x.fk_product,
            store: x.store,
            date: moment(new Date(Date.now())).format(
              "YYYY-MM-DDTHH:mm:ss.SSSSSSZ"
            ),
            quantity: x.quantity_received
          };
          tasks.push(api.postInventoryTransaction(r));
        });
        tasks.push(api.patchDeliverySlip(this.id, data));
        await Promise.all(tasks);
        this.$router.push({ name: "DeliverySlipIndex" });
      } finally {
        this.$store.dispatch("elo");
      }
    }
  }
};
</script>

<style></style>
